import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import {getBusinessUnits} from "../../services/organization";
import ActionButton from "../../components/button/ActionButton";
import {getSpendingsReportByLimits, getSpendingTypeCategories, navLinks} from "../../services/moneyFlow";
import moment from "moment";
import AnyField from "../../components/fields/AnyField";
import {MenuItem} from "@material-ui/core";
import DateField from "../../components/fields/DateField";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

const preColumnData = [
    { id: 'spendingTypeName', label: 'Статья расхода' },
    { id: 'spendingTypeCategory', label: 'Категория' },
];

const styles = theme => ({
    dialogContent: {
        paddingTop:  theme.spacing(1),
    },
    filterControl: {
        marginBottom: 15
    }
});

export default
@withStyles(styles)
class SpendingReportByLimits extends React.Component {
    state = {
        search: {
            search: null,
            month: moment(),
            businessUnitIds: [],
            spendingTypeCategoryIds: []
        },
        refreshTable: false,
        businessUnits: [],
        spendingTypeCategories: [],
        groupBy: 'day',
        columnData: preColumnData
    };

    componentDidMount() {
        getBusinessUnits()
            .then(response => {
                if (response.success) {
                    this.setState({
                        businessUnits: [
                            ...response.data
                        ],
                    });
                }
            });

        getSpendingTypeCategories()
            .then(response => {
                if (response.success) {
                    this.setState({
                        spendingTypeCategories: [
                            ...response.data
                        ],
                    });
                }
            });
    }

    handleChange = prop => event => {
        let value;

        if (event instanceof moment) {
            value = event;
        } else {
            value = event.target.value;
        }

        this.setState({
            search: {
                ...this.state.search,
                [prop]: value,
            }
        });
    };

    handleClickFilter = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    getTableData = (...params) => {
        const {search} = this.state;
        return getSpendingsReportByLimits(search, ...params)
            .then(response => {
                if (response.success) {

                    this.setState({
                        columnData: preColumnData.concat(response.data.columns)
                    });

                    return {
                        success: true,
                        data: response.success ? response.data.data : [],
                    };
                }

                return response;
            });
    };

    render() {
        const { classes } = this.props;
        const { refreshTable, search, businessUnits, columnData, spendingTypeCategories } = this.state;

        return(
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <DateField
                        value={search.month}
                        label="Месяц"
                        onChange={this.handleChange('month')}
                        maxDate={moment()}
                        fullWidth
                        className={classes.filterControl}
                    />
                    <AnyField
                        value={search.businessUnitIds}
                        onChange={this.handleChange('businessUnitIds')}
                        label="Бизнес юниты"
                        select
                        className={classes.filterControl}
                        SelectProps={{
                            multiple: true,
                            displayEmpty: true,
                            renderValue: selected => {
                                if (selected.length === 0) {
                                    return <span className={classes.placeholder}>---Все---</span>;
                                }

                                return businessUnits.filter(item => selected.indexOf(item.id) > -1 ).map(item => item.name).join(', ');
                            },
                        }}
                        fullWidth
                    >
                        {businessUnits.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                <Checkbox checked={search.businessUnitIds.indexOf(item.id) > -1} />
                                <ListItemText primary={item.name} />
                            </MenuItem>
                        ))}
                    </AnyField>
                    <AnyField
                        value={search.spendingTypeCategoryIds}
                        onChange={this.handleChange('spendingTypeCategoryIds')}
                        label="Категории"
                        select
                        SelectProps={{
                            multiple: true,
                            displayEmpty: true,
                            renderValue: selected => {
                                if (selected.length === 0) {
                                    return <span className={classes.placeholder}>---Все---</span>;
                                }

                                return spendingTypeCategories.filter(item => selected.indexOf(item.id) > -1 ).map(item => item.name).join(', ');
                            },
                        }}
                        className={classes.filterControl}
                        fullWidth
                    >
                        {spendingTypeCategories.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                <Checkbox checked={search.spendingTypeCategoryIds.indexOf(item.id) > -1} />
                                <ListItemText primary={item.name} />
                            </MenuItem>
                        ))}
                    </AnyField>

                    <ActionButton onClick={this.handleClickFilter}>Отфильтровать</ActionButton>
                </LeftBar>
                <Content title="Отчет по лимитам">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        selector={false}
                        refresh={refreshTable}
                        onClick={this.handleEdit}
                        pagination={false}
                        disableSorting
                        autoload={false}
                    />
                </Content>
            </React.Fragment>
        );
    }
}
